export interface Route {
    readonly url: () => string;
    readonly pattern: () => string;
}

export const rootRoute: Route = {
    url: () => '/',
    pattern: () => '/',
};
